module.exports = __webpack_public_path__ + "media/IBMPlexSans-Bold.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/IBMPlexSans/IBMPlexSans-Bold.woff
// module id = 1321
// module chunks = 62